import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00004 2.13416V9.74391M10.8537 6.89025L8.00004 9.74391L5.14638 6.89025M14.5 11.0122V11.9634C14.5 12.468 14.2996 12.9519 13.9428 13.3086C13.586 13.6654 13.1021 13.8658 12.5976 13.8658H3.40244C2.89788 13.8658 2.41399 13.6654 2.05721 13.3086C1.70044 12.9519 1.5 12.468 1.5 11.9634V11.0122",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDownload;
